import { Container, css, styled } from "@mui/material";

export const PageElementContainer = styled(Container)(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      padding-left: 16px;
      padding-right: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      padding-left: 48px;
      padding-right: 48px;
    }
  `,
);
